/* eslint-disable */
import axios from "axios";
import store from "@/store";
import soadiffgraph from "../SoAdiff/soadiff.vue";
import soadifftree from "../studyversiondiff/studyversiondiff.vue"

export default {
  name: "NetworkXGraph",
  components: {
    soadiffgraph,
    soadifftree
  },

  data() {
    return {
   isOn: true,
    };
  },

  computed: {
  },

  watch: {
   
    },

  async mounted() {
    window.addEventListener("studyIdChanged", async () => {

    });
  },

  methods: {

  }
};
